import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  return (
    <div className="not-found">
      <div className="not-found__container">
        <div className="not-found__content">
          <div className="not-found__error-code">404</div>
          <h1 className="not-found__title">Page Not Found</h1>
          <p className="not-found__description">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="not-found__actions">
            <Link to="/" className="btn btn--primary">
              Go to Homepage
            </Link>
            <Link to="/shop" className="btn btn--outline">
              Browse Products
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
